import { render } from "./problem_section.html?vue&type=template&id=316bdb74&external"
import script from "./problem_section.js?vue&type=script&lang=js&external"
export * from "./problem_section.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__